export const numberDigital = (star = 1, end = 12 ): number[] => {
    const arr = []
    for (let i = star; i <= end; i++) {
        arr.push(i)
    }
    return arr
}

export const removeLeadingZeros = (str) =>{
    return str.replace(/^0+/, '');
}